export const TaskType = {
  Task: "task",
  Content: "content",
  Survey: "survey",
  Questionnaire: "questionnaire",
};
